export const ShortcutEmojis = ['💖️', '👍', '🤔', '😡', '🤣', '🤭', '🥺', '🤤', '😍', '😭'];
